import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-lg border border-makhe-line bg-makhe-paper p-5 shadow-soft transition-shadow hover:shadow-lift',
        className,
      )}
      {...rest}
    />
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="brand-wash flex flex-col items-center justify-center rounded-lg border border-dashed border-makhe-line px-6 py-16 text-center">
      <img src="/logo-mark.png" alt="" className="mb-4 h-10 w-auto opacity-40 dark:hidden" />
      <img src="/logo-mark-light.png" alt="" className="mb-4 hidden h-10 w-auto opacity-50 dark:block" />
      <h3 className="font-display text-2xl text-makhe-ink">{title}</h3>
      {description && <p className="mt-2 max-w-sm text-sm text-makhe-muted">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function LoadingSkeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-makhe-line/60', className)} />;
}

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-makhe-ink/20 border-t-makhe-ink',
        className,
      )}
    />
  );
}
